import {REQUEST_TYPE} from '../../../constants';
import {doRequest} from '../../../helpers/network';
import {Records} from '../../../helpers/Urls';

const INITIAL_STATE = {
  biltyFsFeesData: [],
  biltyFsFeesDataLoading: false,
  biltyFsFeesDataError: null,
  saveBiltyFsFeesLoading: false,
  saveBiltyFsFeesError: null,
  appliedFilters: {},
};

export const FETCH_BILTY_FS_FEES_COMPLETED = 'FETCH_BILTY_FS_FEES_COMPLETED';
export const BILTY_FS_FEES_LOADING = 'BILTY_FS_FEES_LOADING';
export const BILTY_FS_FEES_ERROR = 'BILTY_FS_FEES_ERROR';
export const SAVE_BILTY_FS_FEES_LOADING = 'SAVE_BILTY_FS_FEES_LOADING';
export const SAVE_BILTY_FS_FEES_ERROR = 'SAVE_BILTY_FS_FEES_ERROR';
export const SAVE_BILTY_FS_FEES_COMPLETED = 'SAVE_BILTY_FS_FEES_COMPLETED';
export const SET_BILTY_FS_FEES_FILTERS = 'SET_BILTY_FS_FEES_FILTERS';

// Fetch Bilty + FS Fees with Filters
export const getBiltyFsFees = (page = 1, BiltyFsFilters) => async (
  dispatch,
) => {
  const {filterStr = ``} = BiltyFsFilters || {};
  dispatch({type: BILTY_FS_FEES_LOADING});

  try {
    const response = await doRequest({
      method: REQUEST_TYPE.GET,
      url: Records.fetchBiltyFsFeesURL(page, filterStr),
    });
    const {data, status} = response || {};

    if (status) {
      dispatch({type: FETCH_BILTY_FS_FEES_COMPLETED, payload: data});
      return {success: true, data};
    } else {
      dispatch({
        type: BILTY_FS_FEES_ERROR,
        error: response?.message || `Failed to fetch Bilty FS Fees`,
      });
      return {
        success: false,
        message: response?.message || `Failed to fetch Bilty FS Fees`,
      };
    }
  } catch (err) {
    dispatch({
      type: BILTY_FS_FEES_ERROR,
      error: err,
    });
    return {
      success: false,
      message: err.message || 'Unexpected error occurred',
    };
  }
};

// Save (Add / Edit)
export const saveBiltyFsFees = (data, id) => async (dispatch) => {
  dispatch({type: SAVE_BILTY_FS_FEES_LOADING});

  try {
    const response = await doRequest({
      method: id ? REQUEST_TYPE.PUT : REQUEST_TYPE.POST,
      url: id ? Records.saveBiltyFsFeesURL(id) : Records.saveBiltyFsFeesURL(),
      data: data,
    });

    if (response.status) {
      dispatch({
        type: SAVE_BILTY_FS_FEES_COMPLETED,
        payload: response.data,
      });
    } else {
      dispatch({
        type: SAVE_BILTY_FS_FEES_ERROR,
        error: response.message,
      });
    }
    return response;
  } catch (err) {
    dispatch({
      type: SAVE_BILTY_FS_FEES_ERROR,
      error: err,
    });
    return {
      status: false,
      message:
        err?.response?.data?.message || err.message || 'Something went wrong',
      error: err,
    };
  }
};

// Reducer
export default (state = INITIAL_STATE, action) => {
  const {type, payload} = action || {};

  switch (type) {
    case BILTY_FS_FEES_LOADING:
      return {...state, biltyFsFeesDataLoading: true};

    case FETCH_BILTY_FS_FEES_COMPLETED:
      return {
        ...state,
        biltyFsFeesDataLoading: false,
        biltyFsFeesData: payload,
      };

    case BILTY_FS_FEES_ERROR:
      return {
        ...state,
        biltyFsFeesDataLoading: false,
        biltyFsFeesDataError: action.error,
      };

    case SAVE_BILTY_FS_FEES_LOADING:
      return {...state, saveBiltyFsFeesLoading: true};

    case SAVE_BILTY_FS_FEES_COMPLETED: {
      const updated = payload; //updated/added item

      const prevRecords = state.biltyFsFeesData?.bilty_fs_record || [];

      const index = prevRecords.findIndex((item) => item?.id === updated?.id);

      let newRecords;
      if (index >= 0) {
        newRecords = [...prevRecords];
        newRecords[index] = {...prevRecords[index], ...updated};
      } else {
        newRecords = [updated, ...prevRecords];
      }

      return {
        ...state,
        saveBiltyFsFeesLoading: false,
        biltyFsFeesData: {
          ...state.biltyFsFeesData,
          bilty_fs_record: newRecords,
          total:
            index >= 0
              ? state.biltyFsFeesData?.total
              : (state.biltyFsFeesData?.total || 0) + 1,
        },
      };
    }

    case SAVE_BILTY_FS_FEES_ERROR:
      return {
        ...state,
        saveBiltyFsFeesLoading: false,
        saveBiltyFsFeesError: action.error,
      };

    case SET_BILTY_FS_FEES_FILTERS:
      return {...state, appliedFilters: payload};

    default:
      return state;
  }
};
